import React from 'react';
import FooterSystem from '../../components/system/FooterSystem';
import ClickBankTrustBadge from '../../components/ClickBankTrustBadge';

export const SystemThankYou: React.FC = () => {
    return (
        <div className="bg-gray-50 flex flex-col min-h-screen">
            <ClickBankTrustBadge />
            {/* Credit Card Statement Banner */}
            <div className="bg-primary-50 border-b border-primary-100">
                <div className="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-center">
                        <p className="text-sm text-primary-700 font-medium">
                            Your credit card statement will show a charge from CLKBANK or CLKBANK*RacingOracle
                        </p>
                    </div>
                </div>
            </div>
            <main className="flex-grow">
                <div className="max-w-2xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                    <div className="bg-white p-8 rounded-lg shadow">
                        {/* Logo */}
                        <div>
                            <img className="mx-auto h-24 w-auto" src="/HRO-Logo-transparent-white-logo.png" alt="Horse Racing Oracle" />
                            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                                Thank You for Your Purchase!
                            </h2>
                        </div>

                        {/* Access Instructions */}
                        <div className="space-y-4 mt-8 text-center">
                            <h3 className="text-lg font-medium text-gray-900">Next Steps:</h3>
                            <div className="flex justify-center">
                                <ol className="list-decimal inline-block text-left space-y-2 mx-auto">
                                    <li>Click the button below to register your account</li>
                                    <li>Complete your account setup</li>
                                    <li>Login to start using Horse Racing Oracle</li>
                                </ol>
                            </div>
                            
                            <div className="mt-6 flex justify-center">
                                <a href="/system/register" className="inline-flex justify-center py-2 px-8 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                                    Create Your Account
                                </a>
                            </div>
                        </div>

                        {/* Support Information */}
                        <div className="border-t border-gray-200 pt-8 mt-8 text-center">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">Need Help?</h3>
                            <a href="/system/contact" className="inline-flex justify-center py-2 px-8 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
                                Contact Us
                            </a>
                        </div>

                        {/* ClickBank Information */}
                        <div className="border-t border-gray-200 pt-8 mt-8 text-center">
                            <p className="text-sm text-gray-500">
                                Your credit card statement will show a charge from CLKBANK or CLKBANK*RacingOracle.
                            </p>
                            <p className="mt-2 text-xs text-gray-400">
                                ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark of Click Sales, Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA and used by permission. ClickBank's role as retailer does not constitute an endorsement, approval or review of these products or any claim, statement or opinion used in promotion of these products.
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <FooterSystem />
        </div>
    );
};

export default SystemThankYou; 